import { useEffect } from 'react';
import { trackPageView } from './analytics';

/**
 * Send one GA4 page_view per route, only while consent is granted.
 * index.html sets send_page_view:false, so this is the only page_view source,
 * including the first route (sent when consent is granted or restored).
 */
export function useSpaPageViews(pathname, search = '', enabled = true) {
  useEffect(() => {
    if (!enabled) return;
    trackPageView(`${pathname}${search}`);
  }, [pathname, search, enabled]);
}
